// All Supabase operations are routed through /api/user-data
// which uses the service role key server-side — anon key never touches these tables

import { apiFetch } from "./apiClient";

const API = "/api/user-data";

async function post(action, body) {
  const res = await apiFetch(API, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ action, ...body }),
  });
  return res.json();
}

async function get(action, params) {
  const query = new URLSearchParams({ action, ...params }).toString();
  const res = await apiFetch(`${API}?${query}`);
  return res.json();
}

// ── Watched Providers ──────────────────────────────────────────────────────

export async function getWatchedProvider(userId, npi) {
  return get("getWatchedProvider", { userId, npi });
}

export async function getWatchedProviders(userId) {
  return get("getWatchedProviders", { userId });
}

export async function watchProvider(userId, npi, providerName, options = {}) {
  return post("watchProvider", {
    userId,
    npi,
    providerName,
    alertPayments: options.alert_payments ?? true,
    alertExclusions: options.alert_exclusions ?? true,
    paymentThreshold: options.payment_threshold ?? null,
    yearlyThreshold: options.yearly_threshold ?? null,
    hasPayments: options.has_payments ?? null,
    hasOwnership: options.has_ownership ?? null,
    hasResearch: options.has_research ?? null,
    isExcluded: options.is_excluded ?? null,    
  });
}

export async function unwatchProvider(userId, npi) {
  return post("unwatchProvider", { userId, npi });
}

// ── Watched Companies ──────────────────────────────────────────────────────

export async function getWatchedCompany(userId, companyName) {
  return get("getWatchedCompany", { userId, companyName });
}

export async function getWatchedCompanies(userId) {
  return get("getWatchedCompanies", { userId });
}

export async function watchCompany(userId, companyName, companyId = null) {
  return post("watchCompany", { userId, companyName, companyId });
}

export async function unwatchCompany(userId, companyName) {
  return post("unwatchCompany", { userId, companyName });
}

// ── Confirmation Queue ─────────────────────────────────────────────────────

export async function queueConfirmation(userId, entityType, entityId, entityName, options = {}) {
  return post("queueConfirmation", {
    userId,
    entityType,
    entityId,
    entityName,
    alertPayments: options.alert_payments ?? true,
    alertExclusions: options.alert_exclusions ?? true,
    paymentThreshold: options.payment_threshold ?? null,
    yearlyThreshold: options.yearly_threshold ?? null,
  });
}

// ── Subscriptions ──────────────────────────────────────────────────────────

export async function getAlertPreferences(userId) {
  return get("getAlertPreferences", { userId });
}

export async function upsertAlertPreferences(userId, email, options = {}) {
  return post("upsertAlertPreferences", { userId, email, ...options });
}

// ── Review Alert Preferences ────────────────────────────────────────────────

export async function getReviewAlertPreference(userId) {
  return get("getReviewAlertPreference", { userId });
}

export async function upsertReviewAlertPreference(userId, reminderFrequency) {
  return post("upsertReviewAlertPreference", { userId, reminderFrequency });
}